<template>
  <div class="main">
    <AllHeader title="组织结构"></AllHeader>
    <div class="wrapper">
      <Gywm title="组织结构"></Gywm>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
import AllHeader from "@/components/AllHeader.vue";
import Gywm from "@/components/GywmContent.vue";
export default {
  data() {
    return {
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
  },
  methods: {
    
  },
  components: {
    AllHeader,Gywm
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 20px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 30px auto;
    .content {
      width: 100%;
      line-height: 1.5;
      color: #000;
    }
  }
}
</style>